import axios from "../../node_modules/axios/index";
import { getToken } from "./authService";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_URL,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`
  },
});

/**
 * Create an authenticated API client that uses the user's JWT token.
 * Falls back to the public API token if not authenticated.
 */
export const getAuthClient = () => {
  const token = getToken();
  if (token) {
    return axios.create({
      baseURL: process.env.REACT_APP_STRAPI_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return apiClient;
};

export default apiClient;
